import RatingRank from './RatingRank'

export default RatingRank
